// components/common/PopupForm.jsx
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '../../features/modal/modalSlice';
import { useState, useEffect } from 'react';

export default function PopupForm() {
  const { isOpen } = useSelector((state) => state.modal);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, dispatch]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
        dispatch(closeModal());
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [success, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target; // THIS LINE IS MISSING
    
    setLoading(true);

    const formData = new FormData(e.target);

    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });

    if (res.ok) {
      setSuccess(true);
      setLoading(false);

      form.reset(); // ✅ clears all fields
    }
  };

  if (!isOpen) return null;


  return (
    <div
      className={`fixed inset-0 z-50 flex items-center md:px-0 px-5 justify-center transition-all duration-300 ${
        isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
      } bg-black/70 backdrop-blur-sm`}
      onClick={() => dispatch(closeModal())}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative w-full max-w-xl transform transition-all duration-300 ${
          isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}
      >
        {/* Glow Border */}
        <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-r from-cyan-500/40 via-blue-500/30 to-purple-500/40 blur-sm opacity-70"></div>

        {/* Modal Content */}
        <div className="relative rounded-2xl border border-white/10 bg-[#050B14]/90 backdrop-blur-xl p-8 shadow-2xl">
          
          {/* Close Button */}
          <button
            onClick={() => dispatch(closeModal())}
            className="absolute right-4 top-4 text-white/50 hover:text-white transition"
          >
            ✕
          </button>

          {/* Heading */}
          <h2 className="text-2xl font-semibold text-white">
            Get in Touch
          </h2>

          <p className="mt-2 text-white/60 text-sm">
            Let’s discuss your requirements and build something powerful.
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <input type="hidden" name="access_key" value="eef15f7d-f8da-4e00-a000-c362e14eb7c0" />
            <input type="hidden" name="subject" value="New Security Enquiry – Stronghold Security" />
            <input type="hidden" name="from_name" value="Stronghold Security Website" />

            {/* Input */}
            <div className="relative">
              <input
                name="name"
                required
                placeholder="Your Name"
                className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-white/40 focus:border-cyan-400 focus:outline-none"
              />
            </div>

            <div className="relative">
              <input
                name="email"
                type="email"
                required
                placeholder="Email Address"
                className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-white/40 focus:border-cyan-400 focus:outline-none"
              />
            </div>

            <div className="relative">
              <input
                name="phonenumber"
                type="text"
                minLength={10}
                maxLength={20}
                required
                placeholder="Enter Mobile Number"
                className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-white/40 focus:border-cyan-400 focus:outline-none"
              />
            </div>

            <div className="relative">
              <textarea
                name="message"
                placeholder="Tell us about your requirement..."
                rows="4"
                className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-white/40 focus:border-cyan-400 focus:outline-none"
              />
            </div>

            {/* CTA Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-gradient-to-r from-cyan-500 to-blue-500 py-3 font-medium text-white transition hover:opacity-90"
            >
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>

          {/* Success State */}
          {success && (
            <div className="mt-6 text-center text-green-400">
              Message sent successfully 🚀
            </div>
          )}
        </div>
      </div>
    </div>
  )
}